import { environment } from '../../../../environments/environment';

export const env = {
    baseUrl: environment.dmsBasePath
}
